import { Add } from '@mui/icons-material';
import { Grid, IconButton, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { ListGroup } from 'react-bootstrap';
import { fetchFailedExecutionIssues } from '../../../../modules/associations';
import SkeletonLoader from '../../../elements/SkeletonLoader';
import { IssueTypeIcon } from '../../../elements/IssueTypeIcon';
import { Guard } from '../../../../features/Guard';

const IssueSuggestions = ({
  entityId,
  linkedIssueIds = [],
  handleAddIssues,
  currentProject,
}) => {
  const { data: allIssueDetails = [], isLoading } = useQuery({
      queryKey: ['failedExecutionIssues', entityId],
      queryFn: async () => {
        const response = await fetchFailedExecutionIssues(entityId);
        return response.issues || [];
      },
      enabled: !!entityId,
    });

  const suggestedIssues = allIssueDetails.filter(
    (issue) => !linkedIssueIds.includes(issue.jira_issue_id)
  );

  const handleAddIssue = (issue) => {
    const data = {
      id: issue.jira_issue_id,
      key: issue.key,
      priority: issue?.priority,
      projectId: issue?.jira_project_id,
    };
    handleAddIssues([data]);
  };

  return (
    <>
      {suggestedIssues?.length > 0 && (
        <Grid
          sx={{
            my: 2,
            padding: '16px',
            backgroundColor: '#bcd5ee',
            border: '1px solid #ddd',
            borderRadius: '8px',
          }}>
          <Typography variant="subtitle1" className="mb-2 fw-bold">Suggested Issues</Typography>
          {isLoading ? (
            <SkeletonLoader />
          ) : (
            <ListGroup as="ol">
              {suggestedIssues?.map((issue) => (
                <ListGroup.Item
                  as="li"
                  action
                  style={{
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer',
                    justifyContent: 'space-between',
                    display: 'flex',
                  }}
                  key={issue.jira_issue_id}
                  className="align-items-center">
                  <div className="d-flex align-items-center flex-grow-1">
                    <span className="me-3" title={issue.issue_type}>
                      <IssueTypeIcon issueType={issue.issue_type} />
                    </span>
                    <a
                      href={`${currentProject?.jira_site_url}/browse/${issue.key}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fw-bold me-3 text-decoration-none">
                      {issue.key}
                    </a>
                    <div className="flex-grow-1">
                      <p className="m-0">{issue.summary?.slice(0, 60)}</p>
                    </div>
                    <div className="badge bg-light text-dark px-2 py-1 rounded text-uppercase">
                      {issue.status}
                    </div>
                  </div>
                  <div className="ms-3">
                    <Guard policy="ManageTraceability">
                    <IconButton
                      size="small"
                      sx={{ color: 'var(--primary-color)' }}
                      title="Add issue"
                      onClick={() => handleAddIssue(issue)}
                      style={{ cursor: 'pointer' }}>
                      <Add fontSize="small" />
                    </IconButton>
                    </Guard>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Grid>
      )}
    </>
  );
};

export default IssueSuggestions;
